module.exports = __webpack_public_path__ + "img/cf247-logo.testB.0ea29cd0.png";